import { PublicKey } from "@solana/web3.js";
import * as NAMESPACES_TYPES from "./idl/cardinal_namespaces";
export const NAMESPACES_PROGRAM_ID = new PublicKey("nameXpT2PwZ2iA6DTNYTotTmiMYusBCYqwBLN2QgF4w");
export const METADATA_CONFIG_SEED = "metadata-config";
export const NAMESPACES_IDL = NAMESPACES_TYPES.IDL;
export const GLOBAL_RENTAL_PERCENTAGE = 0.2;
export const GLOBAL_CONTEXT_SEED = "context";
export const NAMESPACE_SEED = "namespace";
export const ENTRY_SEED = "entry";
export const REVERSE_ENTRY_SEED = "reverse-entry";
export const CLAIM_REQUEST_SEED = "rent-request";
//# sourceMappingURL=constants.js.map